import { render } from "./ClockDrawing.vue?vue&type=template&id=07c36ec6&scoped=true"
import script from "./ClockDrawing.vue?vue&type=script&lang=js"
export * from "./ClockDrawing.vue?vue&type=script&lang=js"

import "./ClockDrawing.vue?vue&type=style&index=0&id=07c36ec6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c36ec6"]])

export default __exports__